export default "__VITE_ASSET__sRce1jZq__"